class CandidateDataCtrl {
  constructor($http, UtilsService) {
    var self = this;
    self.duplicatedLastNameMessage = false;
    self.UtilsService = UtilsService;
    self.busyCreateAccountButton = false;
    self.wasConsentEverShown = false;

    self.state = {
      openCollapseRegister: window.isOfferNotAccepted,
      openCollapseAddress: false,
      checkAgreement1: false,
      checkAgreement2: false,
      passInputType: 'password',
      showNoPesel: false,
      hasTwoCitizenship: false,
      isForeigner: false,
      poland: '',
      forceCreateAccount: window.forceCreateAccount,
      isOfferNotAccepted: window.isOfferNotAccepted,
      isAccountCreated: window.isAccountCreated,
      isInPoland: window.candidate.isInPoland || false,
    };
    self.sku = '';
    self.pricing = {
      'installment': null,
      'entry_fee': null
    };

    self.data = {
      citizenships: [],
      countries: [],
      documentIds: [],
      genders: [],
      residenceDocuments: [],
      phonePrefixes: [],
    };

    self.candidate = {
      firstName: '',
      secondName: '',
      lastName: '',
      email: '',
      consents: '',
      details: {
        citizenship: '',
        secondCitizenship: '',
        //bool
        polesCard: false,
        //date yyyy-MM-dd
        polesCardExpiryDate: null,
        polesCardNumber: null,
        residenceDocument: '',
        //date yyyy-MM-dd
        residenceDocumentExpiryDate: null,
        //date yyyy-MM-dd
        ehicExpiryDate: null,
        //date yyyy-MM-dd
        birthDate: null,
        gender: '',
        originCountry: '',
        pesel: null, //int
        documentIdNumber: '',
        documentIdType: '',
        documentIdCountry: '',
        birthCountry: '',
        birthPlace: '',
        familyName: '',
        fatherName: '',
        motherName: ''
      },
      address: {
        phoneNumberPrefixCountry: null,
        phoneNumber: null,
        country: '',
        streetType: 'ul.',
        street: '',
        streetNumber: '',
        zipCode: '',
        city: ''
      },
      correspondenceAddress: {
        phoneNumberPrefixCountry: null,
        phoneNumber: null,
        country: '',
        streetType: 'ul.',
        street: '',
        streetNumber: '',
        zipCode: '',
        city: '',
      },
      account: {
        password: ''
      }
    };

    self.candidateCopy = {};

    self.appendHistoricalRecruitment = true;
    self.init = function () {
      self.sku = window.sku;
      self.state.poland = window.statics.poland;
      if (typeof window.candidate === 'object') {
        self.candidate = angular.merge(self.candidate, window.candidate);
        if (self.candidate.correspondenceAddress === null) {
          self.candidate.correspondenceAddress = {
            phoneNumberPrefixCountry: null,
            phoneNumber: null,
            country: '',
            streetType: 'ul.',
            street: '',
            streetNumber: '',
            zipCode: '',
            city: '',
          };
        }
        var tempOriginCountry = self.candidate.details.originCountry;
        var tempPesel = self.candidate.details.pesel;
        self.changedCitizenships();
        self.candidate.details.originCountry = tempOriginCountry;
        if(tempPesel !== null) {
          self.candidate.details.pesel = tempPesel;
          self.state.showNoPesel = false;
        } else {
          self.state.showNoPesel = true;
        }
      }

      if ( self.candidate.correspondenceAddress !== null && (
        (self.candidate.correspondenceAddress.street !== '' && self.candidate.correspondenceAddress.street !== null) ||
        (self.candidate.correspondenceAddress.country !== '' && self.candidate.correspondenceAddress.country !== null) ||
        (self.candidate.correspondenceAddress.city !== '' && self.candidate.correspondenceAddress.city !== null)
      )) {
        self.state.openCollapseAddress = true;
      }
    };

    self.toggleShowPassword = function ($event) {
      $event.preventDefault();
      if (self.state.passInputType === 'password') {
        self.state.passInputType = 'text';
      } else {
        self.state.passInputType = 'password';
      }

      $('#account_password').attr('type', self.state.passInputType);
    };

    self.submitRegister = function ($event) {
      $event.preventDefault();
    };

    self.loadCitizenships = function () {
      if (self.data.citizenships.length > 0) {
        return self.data.citizenships;
      }
      $http({
        method: 'GET',
        url: self.UtilsService.getApiPath('api/dict/citizenship')
      }).then(function successCallback(response) {
        self.data.citizenships = response.data;
        return self.data.citizenships;
      });
    }();

    self.changedCitizenships = function () {
      if (self.candidate.details.citizenship !== 'Polish' && self.candidate.details.secondCitizenship !== 'Polish') {
        self.candidate.details.originCountry = null;
        self.state.isForeigner = true;
        self.state.forceCreateAccount = true;
        self.state.openCollapseRegister = true;
        self.state.isInPoland = false;
        this.openCollapseRegisterChange()
      } else {
        self.candidate.details.originCountry = 'Poland';
        self.state.isForeigner = false;
        self.state.forceCreateAccount = self.state.isOfferNotAccepted;
      }

      self.UtilsService.setCallCenter([self.candidate.details.citizenship, self.candidate.details.secondCitizenship]);

      if (typeof self.candidate.details.secondCitizenship !== 'undefined' && self.candidate.details.secondCitizenship !== '' && self.candidate.details.secondCitizenship !== null) {
        self.state.hasTwoCitizenship = true;
      }

      if(!self.state.isForeigner) {
        self.candidate.details.polesCard = false;
        self.candidate.details.polesCardExpiryDate = null;
        self.candidate.details.polesCardNumber = null;
        self.candidate.details.residenceDocument = null;
        self.candidate.details.residenceDocumentExpiryDate = null;

        $('input[name="details[polesCardExpiryDate]"]').val(null)
        $('input[name="details[polesCardExpiryDate]"]').removeClass('ng-touched');
        $('input[name="details[polesCardNumber]"]').val(null)
        $('input[name="details[polesCardNumber]"]').removeClass('ng-touched');

        $('input[name="details[residenceDocumentExpiryDate]"]').val(null)
        $('input[name="details[residenceDocumentExpiryDate]"]').removeClass('ng-touched');
      }
    };

    self.loadCountry = function () {
      if (self.data.countries.length === 0) {
        $http({
          method: 'GET',
          url: self.UtilsService.getApiPath('api/dict/country')
        }).then(function successCallback(response) {
          self.data.countries = response.data;
          return self.data.countries;
        });
      } else {
        return self.data.countries;
      }
    }();
    self.loadDocumentIds = function () {
      if (self.data.documentIds.length === 0) {
        $http({
          method: 'GET',
          url: self.UtilsService.getApiPath('api/dict/document-id')
        }).then(function successCallback(response) {
          self.data.documentIds = response.data;
          return self.data.documentIds;
        });
      } else {
        return self.data.documentIds;
      }
    }();

    self.loadGenders = function () {
      if (self.data.genders.length === 0) {
        $http({
          method: 'GET',
          url: self.UtilsService.getApiPath('api/dict/gender')
        }).then(function successCallback(response) {
          self.data.genders = response.data;
          return self.data.genders;
        });
      } else {
        return self.data.genders;
      }
    }();

    self.loadResidenceDocuments = function () {
      if (self.data.residenceDocuments.length === 0) {
        $http({
          method: 'GET',
          url: self.UtilsService.getApiPath('api/dict/residence-document')
        }).then(function successCallback(response) {
          self.data.residenceDocuments = response.data;
          return self.data.residenceDocuments;
        }, function errorCallback(response) {

        });
      } else {
        return self.data.residenceDocuments;
      }
    }();

    self.loadPhonePrefixes = function () {
      if (0 === self.data.phonePrefixes.length) {
        $http({
          method: 'GET',
          url: self.UtilsService.getApiPath('api/phone-number/prefixes')
        }).then(function successCallback(response) {
          self.data.phonePrefixes = response.data;
          return self.data.phonePrefixes;
        });
      } else {
        return self.data.phonePrefixes;
      }
    }();

    self.toggleHasTwoCitizenship = function ($event) {
      $event.preventDefault();
      self.state.hasTwoCitizenship = self.state.hasTwoCitizenship ? false : true;
    };

    self.addressPostalCodeChange = function () {
      if (self.candidate.address.country === 'Poland') {
        if (!/^\d\d-\d\d\d$/.test(self.candidate.address.zipCode)) {
          return;
        }
        if (self.candidate.address.city === '' || !self.candidate.address.city) {
          $http({
            method: 'GET',
            url: self.UtilsService.getApiPath('api/dict/cityByPostalCode/' + self.candidate.address.zipCode)
          }).then(function success(response) {
            if (response.data.length === 1) {
              self.candidate.address.city = response.data[0].city;
            }
          }, function error() {

          });
        }
      }
    };

    self.correspondenceAddressPostalCodeChange = function () {
      if (self.candidate.correspondenceAddress.country === 'Poland') {
        if (!/^\d\d-\d\d\d$/.test(self.candidate.correspondenceAddress.zipCode)) {
          return;
        }
        if (self.candidate.correspondenceAddress.city === '' || !self.candidate.correspondenceAddress.city) {
          $http({
            method: 'GET',
            url: self.UtilsService.getApiPath('api/dict/cityByPostalCode/' + self.candidate.correspondenceAddress.zipCode)
          }).then(function success(response) {
            if (response.data.length === 1) {
              self.candidate.correspondenceAddress.city = response.data[0].city;
            }
          }, function error() {

          });
        }
      }
    };

    self.getPostalCodePattern = function(country) {
      if (country === 'Poland'){
        return '\\d\\d-\\d\\d\\d';
      }
      return null;
    };

    self.createCopy = function()
    {
      self.candidateCopy = angular.copy(self.candidate);
    };

    self.getDocumentIdPattern = function()
    {
      if (self.showID()) {
        return null;
      }
      if (self.candidate.details.documentIdType !== 'IdentityCard') {
        return null;
      }

      return '[A-Za-z]{3}[0-9]{6}';
    };

    self.validateDocumentId = function()
    {
      if (self.state.isForeigner === true || self.candidate.details.documentIdType !== 'IdentityCard' ||
          self.candidate.details.documentIdNumber === null) {
        return true;
      } else {
        if (self.candidate.details.documentIdNumber.length !== 9) {
          return false;
        }

        var documentIdNumber = self.candidate.details.documentIdNumber.toUpperCase();
        var letterValues = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

        var getLetterValue = function (letter){
          return letterValues.indexOf(letter);
        };

        for (let i=0; i<3; i++) {
          if (getLetterValue(documentIdNumber[i]) < 10 || documentIdNumber[i] === 'O' || documentIdNumber === 'Q') {
            return false;
          }
        }

        for (let i=3; i<9; i++) {
          if (getLetterValue(documentIdNumber[i]) < 0 || getLetterValue(documentIdNumber[i]) > 9)
            return false;
          var sum = 7 * getLetterValue(documentIdNumber[0]) +
              3 * getLetterValue(documentIdNumber[1]) +
              1 * getLetterValue(documentIdNumber[2]) +
              7 * getLetterValue(documentIdNumber[4]) +
              3 * getLetterValue(documentIdNumber[5]) +
              1 * getLetterValue(documentIdNumber[6]) +
              7 * getLetterValue(documentIdNumber[7]) +
              3 * getLetterValue(documentIdNumber[8]);
          sum %= 10;

          if (sum != getLetterValue(documentIdNumber[3])) {
            return false;
          }
        }
        return true;
      }

    };

    self.showPolesCard = function()
    {
      if (window.product.isMba || window.product.isPg) {
        return false;
      }

      return self.state.isForeigner;
    };

    self.showResidenceDocument = function()
    {
      if (window.product.isMba || window.product.isPg) {
        return false;
      }

      return self.state.isForeigner;
    };

    self.showResidenceDocumentInfo = function()
    {
      return 'PartTime' === window.mode
          && self.showResidenceDocument
          && ['Visa', 'Donothave'].includes(self.candidate.details.residenceDocument);
    };

    self.showEhic = function()
    {
      if (window.product.isMba || window.product.isPg) {
        return false;
      }

      return self.state.isForeigner;
    };

    self.showPlaceOfHabitation = function()
    {
      if (window.product.isMaster || window.product.isFirstLevel) {
        return true;
      }

      return false;
    };

    self.showFatherName = function()
    {
      if (self.state.isForeigner) {
        return true;
      }

      return false;
    };

    self.showMotherName = function()
    {
      if (self.state.isForeigner) {
        return true;
      }

      return false;
    };

    self.showID = function()
    {
      return self.state.isForeigner;
    };

    self.showBirthCountry = function()
    {
      return true;
    };

    self.resetPesel = function()
    {
      self.candidate.details.pesel = null;
    };

    self.isResidenceDocumentExpiryDateRequired = function ()
    {
      return self.candidate.details.residenceDocument !== null;
    };

    self.collapseAddress = function()
    {
      console.log('xxx', self.candidate);
      if (self.state.openCollapseAddress === false) {
        self.candidate.correspondenceAddress.country = '';
        self.candidate.correspondenceAddress.zipCode = '';
        self.candidate.correspondenceAddress.street = '';
        self.candidate.correspondenceAddress.streetNumber = '';
        self.candidate.correspondenceAddress.streetType = 'ul.';
        self.candidate.correspondenceAddress.city = '';
      }
    };

    self.checkSecondName = function () {
      self.duplicatedLastNameMessage = self.candidate.secondName.toUpperCase() === self.candidate.lastName.toUpperCase();
    };

    self.isResidenceDocumentExpiryDateRequired = function()
    {
      return (self.state.isForeigner === true &&
        self.candidate.details.residenceDocument !== window.statics.residenceDocumentDoNotHave &&
        self.candidate.details.residenceDocument !== null
      );
    };

    self.User = {
        getProperties: function(key){
            key = key || null;

            if(key.startsWith('choice_')) {
              return `account[consents][${key}]`;
            }

            var properties = {
                'password' : 'account[password]',
                'name' : 'firstName',
                'surname' : 'lastName',
                'email': 'email',
                'pesel' : 'details[pesel]',
                'citizenship' : 'details[citizenship]'
            };

            if (key !== null)
                return properties[key];

            return properties;
        },
        mapField: function(key){
            key = key || null;

            return this.getProperties(key);
        },
        create : function() {
          let userData = {
            user_register_form : {
              password : self.candidate.account.password,
              name : self.candidate.firstName,
              surname: self.candidate.lastName,
              email: self.candidate.email,
              appendHistoricalRecruitment: (!self.state.showNoPesel || !self.state.isForeigner) && self.appendHistoricalRecruitment,
              citizenship: self.candidate.details.citizenship
            }
          };

          if((!self.state.showNoPesel || !self.state.isForeigner) && self.candidate.details.pesel) {
            userData.user_register_form.pesel = self.candidate.details.pesel;
          }

          if(!self.candidate.account.consent) {
            return userData;
          }

          let consents = {};

          Object.keys(self.candidate.account.consent).map(function(key, index) {
            consents[key] = self.candidate.account.consent[key];
          });

          userData.user_register_form.consents = consents;

          return userData;
        }
    };

    self.registerUser = function() {
      self.busyCreateAccountButton = true;

      let handleErrors = function(response) {
        showErrors(response.data.errors.children)
      };

      let showErrors = function(errors) {

        for (const [key, value] of Object.entries(errors)) {

          if(value.errors) {
              const parent = $('[name="' + self.User.mapField(key) +'"]').parent();
              parent.addClass('has-error');

              value.errors.length > 1
                  ? parent.after('<ul class="error-message create-account-error"><li>' + value.errors.join('</li><li>') + '</li></ul>')
                  : parent.after('<ul class="error-message create-account-error"><li>' + value.errors.join('') + '</li></ul>');
          }

          if(value.children) {
            showErrors(value.children)
          }
        }
      };

      let resetErrors = function() {
          $('.create-account-error').remove();
      };

      let scrollToFirstError = function(responseData) {
        let currentPriority = null;
        let currentProperty = null;
        const inputPriorities = {
          'name': 0,
          'surname': 1,
          'email': 2,
          'password': 3
        };

        for (const [property, value] of Object.entries(responseData)) {

          if(!value) {
            continue;
          }

          if(!property || inputPriorities[property] === undefined) {
            continue;
          }

          if(null !== currentPriority && inputPriorities[property] >= currentPriority) {
            continue;
          }

          currentPriority = inputPriorities[property];
          currentProperty = property;
        }

        console.log(currentPriority);

        if(null === currentPriority) {
          return;
        }

        const elementToScroll = $('[name="' + self.User.mapField(currentProperty) +'"]').get(0);
        if(undefined === elementToScroll) {
          return;
        }

        elementToScroll.scrollIntoView();
      };

      $http({
          method: 'POST',
          url: self.UtilsService.getApiPath('api/user/register'),
          data: self.User.create()
      }).then(function successCallback(response) {
          $('#createAccount').html('<div class="alert-success alert-static">' + response.data.message + '</div>');
          resetErrors();
          self.state.isAccountCreated = true;
      }, function errorCallback(response) {
          resetErrors();
          handleErrors(response);

          if(!(response.data && response.data.errors && response.data.errors.children)) {
            return;
          }

          scrollToFirstError(response.data.errors.children);
      }).finally(function () {
         self.busyCreateAccountButton = false;
      });
    };

    self.consentsExpandStatuses = {};

    self.changeConsentExpandStatus = function(consent) {
      if(undefined === this.consentsExpandStatuses[consent]) {
        this.consentsExpandStatuses[consent] = {consent: true, preamble: false};

        return;
      }

      this.consentsExpandStatuses[consent].consent = !this.consentsExpandStatuses[consent].consent;
    };

    self.changePreambleExpandStatus = function(consent) {
      if(undefined === this.consentsExpandStatuses[consent]) {
        this.consentsExpandStatuses[consent] = {preamble: true, consent: false};

        return;
      }

      this.consentsExpandStatuses[consent].preamble = !this.consentsExpandStatuses[consent].preamble;
    };

    self.consentExpandStatus = function(consent) {
      if(undefined === this.consentsExpandStatuses[consent]) {
        return false;
      }

      return this.consentsExpandStatuses[consent].consent;
    };

    self.consentPreambleExpandStatus = function(consent) {
      if(undefined === this.consentsExpandStatuses[consent]) {
        return false;
      }

      return this.consentsExpandStatuses[consent].preamble;
    };

    self.openCollapseRegisterChange = function () {
      if(!this.state.openCollapseRegister) {
        return;
      }

      if(self.wasConsentEverShown) {
        return;
      }

      const checkConsentsVisible = setInterval(function() {
        if ($('.checkbox-list.consents').is(':visible')) {
          $('.consents__text--ellipsis').each(function(index, elem) {
            if(elem.offsetWidth !== elem.scrollWidth){
              $(this).closest('div[class^="consents__"]').find('div.consents__tooltip--hidden').removeClass('consents__tooltip--hidden');
            }
          });

          self.wasConsentEverShown = true;

          clearInterval(checkConsentsVisible);
        }
      }, 100);
    }
  }
}

CandidateDataCtrl.$inject = ['$http', 'UtilsService'];

export default CandidateDataCtrl;
